import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DateSelector from './DateSelector';
import RestaurantSelector from './RestaurantSelector';
import MainTable from './MainTable';
import AddShiftButton from './AddShiftButton';
import CopyShiftButton from './CopyShiftButton';
// import ResetShiftsButton from './ResetShiftsButton'
import SplitLunchTipsButton from './SplitLunchTipsButton';
import SplitDinnerTipsButton from './SplitDinnerTipsButton';
// import PercentageSettings from './PercentageSettings';
import TitleFactor from './TitleFactor';
import TipPool from './TipPool';
import { getRestaurantSettings, getShifts, logout } from '../actions';
import ValidateLunchTipsButton from './ValidateLunchTipsButton';
import ValidateDinnerTipsButton from './ValidateDinnerTipsButton';
import MyShifts from './MyShifts';
import SaveUnsavedDailyShiftsButton from './SaveUnsavedDailyShiftsButton';

const DailyShiftsForm = () => {
  const dispatch = useDispatch();
  const [restaurantId, setRestaurantId] = useState(1);
  const user = useSelector((state) => state.user);
  const date = useSelector((state) => state.dailyShifts.date);
  const navigate = useNavigate();
  useEffect(() => {
    if (user.RestaurantID === 0) {
      dispatch(getRestaurantSettings(restaurantId));
      dispatch(getShifts(restaurantId, date));
    }
  }, [dispatch, restaurantId, user, date]);
  const dailyShifts = useSelector((state) => state.dailyShifts);
  const changeRestaurant = (restaurantId) => {
    setRestaurantId(restaurantId);
    dispatch(getRestaurantSettings(restaurantId));
  };
  return (
    <div className="container">
      {user.Name && (
        <div>
          <h1 className="header text-center">Soto Payroll System</h1>
          <br />
          <h4>Welcome {user.Name}</h4> <button onClick={logout}>Logout</button>
          &nbsp;&nbsp;&nbsp;
          <button
            onClick={() => {
              navigate('/employee');
            }}
          >
            Manage Employee
          </button>
          &nbsp;&nbsp;&nbsp;
          <button
            onClick={() => {
              navigate('/report');
            }}
          >
            View Reports
          </button>
          {user.RestaurantID === 0 ? (
            <div>
              <RestaurantSelector
                restaurantId={restaurantId}
                handleChangeRestaurant={changeRestaurant}
              />
              <DateSelector
                restaurantId={restaurantId}
                date={dailyShifts.date}
              />
              <p />
              <AddShiftButton />
              &nbsp;&nbsp;&nbsp;&nbsp;
              <CopyShiftButton />
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              {/* <ResetShiftsButton restaurantId={restaurantId} date={dailyShifts.date}/>  */}
              <SplitLunchTipsButton /> <SplitDinnerTipsButton />{' '}
              <SaveUnsavedDailyShiftsButton />
              <ValidateLunchTipsButton /> <ValidateDinnerTipsButton />
              <p />
              {/* <PercentageSettings sushiPercentage={dailyShifts.restaurant.SushiPercentage} barPercentage={dailyShifts.restaurant.BarPercentage}
            hostPercentage={dailyShifts.restaurant.HostPercentage} expoPercentage={dailyShifts.restaurant.ExpoPercentage} 
            busserPercentage={dailyShifts.restaurant.BusserPercentage} lunchExpoPercentage={dailyShifts.restaurant.LunchExpoPercentage}/> */}
              <TitleFactor
                hostFactor={dailyShifts.hostFactor}
                expoFactor={dailyShifts.expoFactor}
                busserFactor={dailyShifts.busserFactor}
              />
              <p />
              <MainTable
                restaurantId={restaurantId}
                shifts={dailyShifts.shifts}
              />
              <p />
              <TipPool dailyShifts={dailyShifts} />
            </div>
          ) : (
            <MyShifts />
          )}
        </div>
      )}
    </div>
  );
};

export default DailyShiftsForm;
